// extracted by mini-css-extract-plugin
export var animationToLeftSide = "ScrollingItems-module--animationToLeftSide--f4543";
export var elementsContainer = "ScrollingItems-module--elementsContainer--60b2c";
export var elementsContainerCopy = "ScrollingItems-module--elementsContainerCopy--bf378";
export var elementsWrapper = "ScrollingItems-module--elementsWrapper--2a2c0";
export var infiniteScroll = "ScrollingItems-module--infinite-scroll--3dba6";
export var leftInfiniteScroll = "ScrollingItems-module--left-infinite-scroll--dc66a";
export var stopOnLargerScreens = "ScrollingItems-module--stopOnLargerScreens--d1581";